// Global Instructions Rule Applied!
//
// Inline number cell for the Pipelines config tables. Holds a local value while
// the user types and only commits (persists) on blur or Enter, and only when
// the value actually changed — so editing in-table doesn't fire a write per
// keystroke. null means "blank" (no threshold / no max-age).
import React, { useEffect, useState } from 'react'
import { InputNumber } from 'antd'

interface InlineNumberFieldProps {
  value: number | null
  min?: number
  /** Upper bound, where the backing setter enforces one (the agent config
   *  panels). Client-side clamping only makes the ceiling discoverable — the
   *  RPC is authoritative and refuses an out-of-range value regardless. */
  max?: number
  placeholder?: string
  width?: number
  onCommit: (value: number | null) => void
}

export default function InlineNumberField({
  value,
  min = 0,
  max,
  placeholder = '—',
  width = 64,
  onCommit
}: InlineNumberFieldProps): React.ReactElement {
  const [v, setV] = useState<number | null>(value)
  useEffect(() => {
    setV(value)
  }, [value])

  const commit = (): void => {
    if (v !== value) onCommit(v)
  }

  return (
    <InputNumber
      size="small"
      min={min}
      max={max}
      placeholder={placeholder}
      value={v ?? undefined}
      style={{ width }}
      controls={false}
      onChange={(x) => setV(typeof x === 'number' ? x : null)}
      onBlur={commit}
      onPressEnter={commit}
    />
  )
}
